import { NgModule } from '@angular/core';
import { PdfViewerComponent } from './pdf-viewer.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [PdfViewerComponent],
  exports: [PdfViewerComponent],
})
export class PdfViewerModule {}
